import clsx from 'clsx';
import React from 'react';

import { PrimaryButton, ProButton } from '@components/Button/variants';
import IconAppQRCode from '@components/Images/IconAppQRCode';

interface DownloadAppProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
}

const DownloadApp = ({ handleNext, isProSubscriber }: DownloadAppProps) => {
  const Button = isProSubscriber ? ProButton : PrimaryButton;

  return (
    <div className="w-[416px] bg-grayscale-charcoal px-32 py-24">
      <h2 className="my-0 text-center font-suisse-screen text-headline-alt-sm font-medium text-white">
        You&apos;re all set
      </h2>
      <div className="mt-24 flex flex-col items-center gap-8">
        <p className="my-0 font-suisse-screen text-byline-lg text-white">
          Scan to download the app
        </p>
        <IconAppQRCode
          className={clsx('border border-solid', {
            'border-primary-magenta': !isProSubscriber,
            'border-pro-gold': isProSubscriber,
          })}
        />
      </div>
      <Button as="button" size="small" className="mt-24 w-full" onClick={handleNext}>
        Done
      </Button>
    </div>
  );
};

export default DownloadApp;
